module.exports = __webpack_public_path__ + "img/image2.3c870309.jpg";